export const navigation = {
  chat: "Chat",
  newChat: "Nuevo Chat",
  chatHistory: "Historial de Chat",
  login: "Iniciar Sesión", // More common than "Entrar"
  settings: "Configuraciones",
};
